/**
 * Grupo de `ConfirmDialog` del módulo: así un `confirmDialog({ group })` de
 * metas no dispara los diálogos de otras pantallas (ni al revés).
 *
 * Vive aquí, en un módulo neutral, y no en el panel de Accesos: lo importan la
 * Captura, la Autorización, las condiciones de tienda y la sección de metas de
 * Usuarios, que no tienen nada que ver con asignar accesos.
 */
export const GRUPO_CONFIRMAR = 'metas-colaborador';
